import styled from "styled-components";

import BgRota from "../../assets/images/BackgroundRota.jpeg"

export const HeaderContainer = styled.div`
    background-image: url(${BgRota});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    height: 200px;
    padding: 20px;
`;

export const StoreInformation = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`;

export const ImageStore = styled.img`
    height: 100px;
    width: 100px;
    border-radius: 50%;
    margin-right: 20px;
    border: 2px solid #fafbfc;
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.8));
`; 

export const NameStore = styled.span`
    font-size: 25px;
    color: #fafbfc;
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.8));
`;